"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUDIT_LOG_MAX_RANGE_DAYS = exports.AUDIT_LOG_DEFAULT_RANGE_DAYS = exports.AUDIT_TARGET_TYPES = exports.AUDIT_TARGET_LABEL = exports.AUDIT_ACTION_GROUP_TYPES = exports.AUDIT_ACTION_GROUP_LABEL = exports.AUDIT_ACTION_GROUPS = exports.AUDIT_ACTION_TYPES = exports.AUDIT_ACTION_LABEL = void 0;
exports.auditTargetLabel = auditTargetLabel;
exports.auditActionLabel = auditActionLabel;
/**
 * 감사 로그(관리자 작업 이력) 조회 — `audit_log`를 화면에서 읽는 계약.
 *
 * 왜 있나: 계약 백엔드 범위 "관리자 작업 이력(감사 로그) 및 단말기 통신 로그 조회". 기록은
 * 인터셉터(`common/audit/`)가 전 CUD 라우트에 자동으로 남기고 인증 이벤트는 서비스가 직접
 * 남긴다. 이 파일은 그 기록을 **읽는** 쪽의 계약이다 — 읽는 코드는 서버 `audit-logs/` 모듈
 * 한 곳에만 둔다.
 *
 * **본사 전용**이다. "관리자 작업 이력"이고, 로그인 실패처럼 `user_id`가 비는 행은 소속 조직이
 * 없어 대리점 기준으로 좁힐 수 없다. 대리점 개방은 조직 되짚기·소속 없는 행의 정책이 따라오는
 * 별개 일이다.
 */
/**
 * 작업 종류 → 한글 명칭.
 *
 * 값의 원천은 두 곳이다 — 인터셉터의 HTTP 메서드 파생(CREATE/UPDATE/DELETE)과 수동 기록
 * (DEPLOY, 인증 이벤트 8종). 서버의 `AUDIT_ACTION` 상수는 이 표의 **키에서 파생**한다.
 * 여기 없는 값을 기록하면 컴파일이 깨진다 — 표와 기록이 어긋나 화면에 코드가 그대로 찍히는
 * 사고를 막는다.
 */
exports.AUDIT_ACTION_LABEL = {
    CREATE: '등록',
    UPDATE: '수정',
    DELETE: '삭제',
    DEPLOY: '배포',
    /**
     * 배정 — 제품을 대리점·Agent에 배정(`devices.service.ts` assign)하거나 가맹점 관리 업체를 바꿔
     * 그 단말 제품이 따라 옮겨질 때(`merchants.service.ts`). 2026-09-22 전에는 `UPDATE`(수정)로 남아
     * "배포"로도 "수정"으로도 배정만 골라낼 수 없었다(대표 U6 ⑤). 옛 기록은 `UPDATE` 그대로다
     */
    ASSIGN: '배정',
    LOGIN: '로그인',
    LOGIN_FAILED: '로그인 실패',
    LOGOUT: '로그아웃',
    SESSION_EXTEND: '세션 연장',
    PASSWORD_CHANGE: '비밀번호 변경',
    PASSWORD_CHANGE_FAILED: '비밀번호 변경 실패',
    PASSWORD_RESET: '비밀번호 초기화',
    PASSWORD_RESET_MAIL_FAILED: '비밀번호 초기화 메일 실패',
};
/** 필터 선택지 순서 = 선언 순서 */
exports.AUDIT_ACTION_TYPES = Object.keys(exports.AUDIT_ACTION_LABEL);
/**
 * 작업 묶음 — 인증 계열 8종을 화면에서 3갈래로 고른다 (2026-09-22 대표 U6 ⑪ "로그인·세션연장·비밀번호로 통일").
 * 기록 코드는 그대로 두고 **조회 단에서만** 묶는다 — 실패·메일 실패를 따로 볼 일이 있어서다.
 */
exports.AUDIT_ACTION_GROUPS = {
    auth: ['LOGIN', 'LOGIN_FAILED', 'LOGOUT'],
    session: ['SESSION_EXTEND'],
    password: [
        'PASSWORD_CHANGE',
        'PASSWORD_CHANGE_FAILED',
        'PASSWORD_RESET',
        'PASSWORD_RESET_MAIL_FAILED',
    ],
};
/** 작업 묶음 한글 명칭 — 필터 선택지 */
exports.AUDIT_ACTION_GROUP_LABEL = {
    auth: '로그인',
    session: '세션 연장',
    password: '비밀번호',
};
exports.AUDIT_ACTION_GROUP_TYPES = Object.keys(exports.AUDIT_ACTION_GROUPS);
/**
 * 대상 종류 → 한글 명칭. 값은 테이블명이다(인터셉터가 컨트롤러 경로를 `TARGET_TYPE_BY_PATH`로
 * 옮긴 것 + 수동 기록이 적은 것).
 *
 * 인터셉터는 표에 없는 경로 세그먼트를 **그대로** target_type에 넣으므로, 여기 없는 값이
 * 저장돼 있을 수 있다. 화면은 표에 없으면 값을 그대로 보여 준다(`auditTargetLabel`).
 */
exports.AUDIT_TARGET_LABEL = {
    app_user: '사용자',
    organization: '업체',
    // VAN/PG 업체의 PG 업체 목록 추가·삭제 (2026-09-22 리뷰 W3 — 전에는 `organization`으로 남았다)
    org_pg_company: 'PG 업체',
    notice: '공지사항',
    product: '모델',
    product_current_version: '모델 운영 버전',
    update_package: '펌웨어 등록',
    device: '제품',
    merchant: '가맹점',
    // 하드웨어·Pay Vcat 행 공통(등록·수정·삭제). 구분은 detail 앞머리('하드웨어'/'Pay Vcat')에 있다
    merchant_terminal: '가맹점 단말',
    terminal_setting: 'PayVcat 설정보기',
    deploy_job: '배포',
    menu_visibility: '메뉴 권한',
    as_request: 'A/S',
    // 단말이 올린 로그 파일 삭제 (2026-09-30 — `DELETE /log-files/:fileId`, 인터셉터 자동 기록)
    upload_file: '로그 파일',
};
/** 필터 선택지 순서 = 선언 순서 */
exports.AUDIT_TARGET_TYPES = Object.keys(exports.AUDIT_TARGET_LABEL);
/** 대상 종류 한글 명칭 — 표에 없으면 값 그대로, null이면 null */
function auditTargetLabel(targetType) {
    if (targetType === null) {
        return null;
    }
    return exports.AUDIT_TARGET_LABEL[targetType] ?? targetType;
}
/** 작업 종류 한글 명칭 — 표에 없으면 값 그대로 (옛 기록의 낯선 코드도 숨기지 않는다) */
function auditActionLabel(actionType) {
    return actionType in exports.AUDIT_ACTION_LABEL
        ? exports.AUDIT_ACTION_LABEL[actionType]
        : actionType;
}
/**
 * 조회 기본 기간 — 오늘(KST)에서 며칠 전까지 거슬러 여는가.
 *
 * 감사 로그는 통신 로그보다 훨씬 희소하다(사람 조작 한 번에 1행, 왕복당 2행이 아니다).
 * 일주일이면 "지난주 누가 바꿨나"가 첫 화면에 들어온다.
 */
exports.AUDIT_LOG_DEFAULT_RANGE_DAYS = 7;
/**
 * 조회 기간 상한(일) — 넘으면 400.
 *
 * 보관은 무기한이라 상한이 없으면 전 구간 스캔이 되고 엑셀은 그 전량을 메모리에 올린다.
 * 분기 단위면 "지난 분기 그 변경"까지 닿는다.
 */
exports.AUDIT_LOG_MAX_RANGE_DAYS = 90;
